import * as React from 'react';

type CopyIconProps = React.SVGProps<SVGSVGElement>;

export const CopyIcon: React.FC<CopyIconProps> = React.memo(({ height = 22.39, width = 22.39, ...props }) => {
    return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className='svg-icon' height={height} width={width} {...props}>
            <path d="M8.25 7.5V5.25C8.25 4.00736 9.25736 3 10.5 3H18.75C19.9926 3 21 4.00736 21 5.25V13.5C21 14.7426 19.9926 15.75 18.75 15.75H16.5M8.25 7.5H5.25C4.00736 7.5 3 8.50736 3 9.75V18.75C3 19.9926 4.00736 21 5.25 21H14.25C15.4926 21 16.5 19.9926 16.5 18.75V15.75M8.25 7.5H14.25C15.4926 7.5 16.5 8.50736 16.5 9.75V15.75" stroke="#0F172A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
        </svg>
    );
});
